<script setup>
import tankImage from '../../assets/indicators/horizontal-tank.png'

defineProps({
  tanks: { type: Array, default: () => [] },
  emptyMessage: { type: String, default: 'Дані відсутні' },
})

const number = (value, digits = 0) => value == null ? '—' : new Intl.NumberFormat('uk-UA', { maximumFractionDigits: digits }).format(value)
const bandLabel = { high: 'Високий', medium: 'Середній', low: 'Низький', critical: 'Критичний', unconfigured: 'Не налаштовано' }
</script>

<template>
  <section class="indicator-section" aria-labelledby="tanks-heading">
    <h2 id="tanks-heading"><span>03</span> Залишки в резервуарах</h2>
    <div class="dashboard-panel tank-panel">
      <div v-if="tanks.length" class="tank-grid">
        <article v-for="tank in tanks" :key="tank.tankNumber" class="tank-card" :class="`tank-${tank.fillBand}`">
          <header><strong>№{{ tank.tankNumber }}</strong><span>{{ tank.productName || 'Невідомий нафтопродукт' }}</span></header>
          <img :src="tankImage" alt="" />
          <progress v-if="tank.fillPercent != null" :value="tank.fillPercent" max="100" :aria-label="`Заповненість резервуара №${tank.tankNumber}`"></progress>
          <dl><div><dt>Висота</dt><dd>{{ number(tank.heightMm, 2) }} мм</dd></div><div><dt>Об'єм</dt><dd>{{ number(tank.currentLiters, 2) }} л</dd></div><div><dt>Місткість</dt><dd>{{ number(tank.capacityLiters, 2) }} л</dd></div><div><dt>Заповнення</dt><dd>{{ tank.fillPercent == null ? '—' : `${number(tank.fillPercent, 2)}%` }}</dd></div><div><dt>Статус</dt><dd>{{ bandLabel[tank.fillBand] }}</dd></div></dl>
        </article>
      </div>
      <p v-else class="section-unavailable">{{ emptyMessage }}</p>
      <div v-if="tanks.length" class="tank-legend" aria-label="Градації заповненості"><span class="legend-high">75–100% · Високий</span><span class="legend-medium">50–75% · Середній</span><span class="legend-low">25–50% · Низький</span><span class="legend-critical">0–25% · Критичний</span></div>
      <p v-if="tanks.length" class="tank-note">Рівні заповнення розраховані від налаштованої місткості резервуара.</p>
    </div>
  </section>
</template>
